export default __webpack_public_path__ + "static/media/microsoft-normal.99bf5571.svg";